
const sampleList = [
  {
    title: "Sample Signature",
    text:
      "Signature is required to validate with the PAN card signature and a mandatory requirement for completion of KYC",
    img: process.env.REACT_APP_IMAGES_PATH + "sign.webp",
    points: [
      {
        isCorrect: true,
        text: "Signature should be clear",
      },
      {
        isCorrect: true,
        text: "It should match with the signature in PAN Card",
      },
      {
        isCorrect: false,
        text: "Image should not be blurred",
      },
    ],
  },
  {
    title: "Sample PAN Card",
    text:
      "PAN card is used as Proof of identification and is a mandatory requirement for completion of KYC",
    img: process.env.REACT_APP_IMAGES_PATH + "PAN.webp",
    points: [
      {
        isCorrect: true,
        text: "Image should be clear and completely visible",
      },
      {
        isCorrect: true,
        text:
          "All the details Name, Father's Name & DOB should be properly visible ",
      },
      {
        isCorrect: false,
        text: "Image should not be blurred",
      },
    ],
  },
  {
    title: "Sample Address Proof(Front)",
    text:
      "All valid address proof are accepted and is a mandatory requirement for completion of KYC",
    img: process.env.REACT_APP_IMAGES_PATH + "front.webp",
    points: [
      {
        isCorrect: true,
        text: "Image should be clear and completely visible",
      },
      {
        isCorrect: true,
        text: "All the details Name, DOB & Address should be properly visible ",
      },
      {
        isCorrect: true,
        text:
          "Note- For one sided valid address proofs, please upload the same file in both front and back options",
      },
      {
        isCorrect: true,
        text:
          "Image should be self-attested",
      },
      {
        isCorrect: false,
        text: "Image should not be blurred",
      },
      {
        isCorrect: false,
        text: "Image should be of a valid Address Proof",
      },
    ],
  },
  {
    title: "Sample Address Proof(Back)",
    text:
      "All valid address proof are accepted and is a mandatory requirement for completion of KYC",
    img: process.env.REACT_APP_IMAGES_PATH + "back.webp",
    points: [
      {
        isCorrect: true,
        text: "Image should be clear and completely visible",
      },
      {
        isCorrect: true,
        text: "All the details Name, DOB & Address should be properly visible ",
      },
      {
        isCorrect: true,
        text:
          "Note- For one sided valid address proofs, please upload the same file in both front and back options",
      },
      {
        isCorrect: true,
        text:
          "Image should be self-attested",
      },
      {
        isCorrect: false,
        text: "Image should not be blurred",
      },
      {
        isCorrect: false,
        text: "Image should be of a valid Address Proof",
      },
    ],
  },
  {
    title: "Sample Photograph",
    text:
      "Photograph is required to verify the user's identity and is mandatory for completion of KYC",
    img: process.env.REACT_APP_IMAGES_PATH + "photo.webp",
    points: [
      {
        isCorrect: true,
        text: "Image should be clear and completely visible",
      },
      {
        isCorrect: true,
        text:
          "Image should be matching with the one in the PAN & Address Proof",
      },
      {
        isCorrect: false,
        text: "Image should not be blurred",
      },
    ],
  },
  {
    title: "Sample IPV",
    text:
      "In-Person Verification (IPV) video is used to verify and authenticate the user's identity and is a mandatory requirement for completion of KYC.",
    img: "https://assets.biddeasy.com/images/mp4/sampleIPV.mp4",
    isVideo: true,
    points: [
      {
        isCorrect: true,
        text: "The self recorded video should be clear",
      },
      {
        isCorrect: true,
        text: "Press the record button and say the onscreen OTP aloud",
      },
      {
        isCorrect: true,
        text:
          " It should be recorded by the person who's details are being furnished.",
      },
      {
        isCorrect: false,
        text: "Video should not be blurred",
      },
    ],
  },
  {
    title: "Sample Bank Proof",
    isBank: true,
    text: "",
    img: process.env.REACT_APP_IMAGES_PATH + "sample_bank.webp",
    points: [
      {
        isCorrect: true,
        text: "Image should be clear and completely visible",
      },
      {
        isCorrect: true,
        text: "Image should clearly display Bank A/c, IFSC code",
      },
      {
        isCorrect: true,
        text:
          "Valid bank proofs are: latest Bank Statement, cheque or Passboook",
      },
      {
        isCorrect: false,
        text: "Image should not be blurry",
      },
      {
        isCorrect: false,
        text: "Image should have bank proof",
      },
    ],
  },
  {
    title: "Sample Aadhaar",
    text: "Aadhaar is required to verify the user's identity",
    img: process.env.REACT_APP_IMAGES_PATH + "Aadhar.webp",
    points: [
      {
        isCorrect: true,
        text: "Image should be clear and completely visible",
      },
      {
        isCorrect: true,
        text:
          "Image should be matching with the one in the PAN & Address Proof",
      },
      {
        isCorrect: false,
        text: "Image should not be blurred",
      },
    ],
  },
  {
    title: "Sample Cheque",
    text: "",
    img: process.env.REACT_APP_IMAGES_PATH + "Cheque.webp",
    points: [
      {
        isCorrect: true,
        text: "Image should be clear and completely visible",
      },
      {
        isCorrect: true,
        text: "Image should clearly display Bank A/c, IFSC code",
      },
      {
        isCorrect: false,
        text: "Image should not be blurred",
      },
    ],
  },
];

export const getSample = (type) => {
  switch (type) {
    case "sign":
      return sampleList[0];
    case "pan":
      return sampleList[1];
    case "address":
      return sampleList[2];
    case "address_1":
      return sampleList[3];
    case "photo":
      return sampleList[4];
    case "ipv":
      return sampleList[5];
    case "bank":
      return sampleList[6];
    case "aadhaar":
      return sampleList[7];
    case "cheque":
      return sampleList[8];
    default:
      return sampleList[0];
  }
};
